import React from "react";
import { Row, Col, Container } from "react-bootstrap";

import '../../Components/landing.css';
import '../../theme/index.css';

export const Applications = () => {
    return (
<Container fluid className="cream-bkg">
<Row className="justify-content-center text-center p-3 pt-5 mx-0">
                    <Col md={8}>
                        <h2 className="bluegray-text">Applications are open for Vendors, Sponsors & Instructors!</h2>
                    </Col>
                </Row>
                <Row className="px-2 justify-content-center mx-0 bluegray-text">
                    <Col xs={10} md="auto" className="p-2">
                        <h3>SPONSORS</h3>
                        <h4>• 6 Tiers Available</h4>
                        <h4>• Starting at $50</h4>
                        <h4>• Social Media Mentions</h4>
                        <h4>• Raffle Tickets And More</h4>
                    </Col>

                    <Col xs={10} md={{span: "auto", offset: 1}} className="p-2">
                        <h3>VENDORS</h3>
                        <h4>• $75/Booth</h4>
                        <h4>• 10X10 Vendor Booth</h4>
                        <h4>• Social Media Mentions</h4>
                        <h4>• Link and Logo on Website</h4>
                    </Col>
                </Row>
                <Row className="justify-content-center text-center mx-0">
                    <Col md={2} xs={11} className="py-4 mb-5">
                        <a href="https://docs.google.com/forms/d/e/1FAIpQLSf56jtPyiJXT9AVBon0dDnW9CaMhbHudx4XSlgkRhefCPQS7g/viewform?pli=1" target="_blank" rel="noreferrer">
                            <button>
                                APPLY
                            </button>
                        </a>
                    </Col>
                </Row>
</Container>
    )
};